module.exports = __webpack_public_path__ + "media/images/area/feature/shikoku/related/zh-hant/5-c1a14de6fe5ae3db307dc067e7a234ba.jpg";